import { CloseOutlined, ContentCopyOutlined } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";
import { toast } from "react-toastify";
import { useGroupControls } from "../hooks";
import AccessibleIconButton from "components/base/AccessibleIconButton";

export default function GroupCodeListItem({ groupCode, ...props }) {
  const { deleteGroupCode, getGroupCodes } = useGroupControls();

  async function handleDelete() {
    await deleteGroupCode(groupCode);
    await getGroupCodes();
    toast.success(`Group code '${groupCode.code}' as been deleted`);
  }
  return (
    <Stack
      component="li"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      {...props}
    >
      <Typography
        component="div"
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {groupCode.code}{" "}
        <AccessibleIconButton
          onClick={() => {
            navigator.clipboard.writeText(groupCode.code);
            toast.info(
              `Code '${groupCode.code}' has been copied to your clipboard.`
            );
          }}
          size="small"
          title="Copy Group Code"
        >
          <ContentCopyOutlined fontSize="inherit" />
        </AccessibleIconButton>
      </Typography>
      <AccessibleIconButton
        size="small"
        onClick={handleDelete}
        title="Delete Group Code"
        tooltipProps={{
          placement: "right",
        }}
      >
        <CloseOutlined fontSize="inherit" />
      </AccessibleIconButton>
    </Stack>
  );
}
